module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_youtube-c4beea7c084bf984f56426771670a377.svg";